<template>
  <div style="padding: 15px">
    <el-form ref="form" :model="queryForm" :inline="true">
      <el-form-item label="用户名称">
        <el-input
          v-model="queryForm.user_name"
          clearable
          placeholder="请输入姓名"
        />
      </el-form-item>
      <el-form-item label="编号">
        <el-input v-model="queryForm.code" clearable placeholder="请输入姓名" />
      </el-form-item>
      <el-form-item label="包裹日期">
        <el-date-picker
          v-model="queryForm.times"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm:ss"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="timeChange"
        >
          >
        </el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-button
          icon="el-icon-search"
          type="primary"
          native-type="submit"
          @click="handleQuery"
        >
          查询
        </el-button>
        <el-button
          icon="el-icon-search"
          type="primary"
          native-type="submit"
          @click="out()"
        >
          批量导出
        </el-button>
      </el-form-item>
    </el-form>
    <el-table
      ref="tableSort"
      v-loading="listLoading"
      :data="list"
      :element-loading-text="elementLoadingText"
      height="75vh"
      border
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column
        prop="code"
        label="编号"
        align="center"
        min-width="120"
      ></el-table-column>
      <el-table-column prop="label" label="拍照" align="center" min-width="100">
        <template #default="{ row }">
          <!-- <img style="width: 60px; height: 60px;" v-for="(item,index) in row.pic" :key="index" :src="item" alt="" /> -->
          <el-image
            v-for="(item, index) in row.pic"
            :key="index"
            style="width: 60px; height: 60px"
            :src="item"
            :preview-src-list="row.pic"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column
        prop="long"
        label="尺寸"
        align="center"
        min-width="120"
      ></el-table-column>
      <el-table-column
        prop="weight"
        label="重量"
        align="center"
        min-width="70"
      ></el-table-column>
      <el-table-column
        prop="num"
        label="数量"
        align="center"
        min-width="70"
      ></el-table-column>
      <el-table-column
        prop="reinforce"
        label="物品加固"
        align="center"
        min-width="100"
      ></el-table-column>
      <el-table-column
        prop="carton"
        label="纸箱类型"
        align="center"
        min-width="100"
      ></el-table-column>
      <el-table-column
        prop="courier_bag"
        label="快递袋类型"
        align="center"
        min-width="100"
      ></el-table-column>
      <el-table-column
        prop="item"
        label="包裹内物"
        align="center"
        min-width="120"
      ></el-table-column>
      <el-table-column
        prop="label"
        label="贴产地标"
        align="center"
        min-width="100"
      >
        <template #default="{ row }">
          {{ row.label == 1 ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column
        prop="face_veneer"
        label="贴面单"
        align="center"
        min-width="70"
      >
        <template #default="{ row }">
          {{ row.face_veneer == 1 ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column
        prop="other"
        label="其他"
        align="center"
        min-width="120"
      ></el-table-column>
      <el-table-column
        prop="user_name"
        label="用户"
        align="center"
        min-width="120"
      ></el-table-column>
      <el-table-column
        label="创建时间"
        prop="add_time"
        min-width="120"
        sortable
        align="center"
      ></el-table-column>
      <el-table-column
        label="操作面板"
        width="150px"
        fixed="right"
        align="center"
      >
        <template #default="{ row }">
          <el-button type="text" @click="edit(row)">详情</el-button>
          <el-button type="text" style="color: red" @click="del_item(row)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="queryForm.page"
      :layout="layout"
      :page-size="queryForm.limit"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    ></el-pagination>
    <edit ref="userAdd" @formChange="fetchData()"></edit>
  </div>
</template>

<script>
  import edit from './edit.vue'
  import { baseURL_print, getUploadUrl } from '@/config'
  import {
    MonadOrder_update, //新用户添加修改
    MonadOrder_detail, //详情
    MonadOrder_del, //删除
    MonadOrder_list, //列表
    MonadOrder_excel_out, //导出
  } from '@/api/new_user.js'
  import { uploadFileZdh } from '@/api/xgcApi'
  export default {
    components: {
      edit,
    },
    data() {
      return {
        multipleSelection: [],
        uploadFileUrl: baseURL_print + 'index/index/file',
        listLoading: true,
        elementLoadingText: '加载中...',
        list: [],
        total: 0,
        layout: 'total, sizes, prev, pager, next, jumper',
        queryForm: {
          page: 1,
          limit: 20,
          keyword: '',
          times: [],
          end_time: '',
          start_time: '',
          user_name: '',
        },
      }
    },
    created() {},
    beforeDestroy() {},
    mounted() {
      this.getTIme()
    },
    methods: {
      getTIme() {
        var dates = this.getCurrentAndTomorrowDates()
        this.queryForm.times[0] = dates.today
        this.queryForm.times[1] = dates.tomorrow
        this.queryForm.start_time = dates.today
        this.queryForm.end_time = dates.tomorrow
        this.fetchData()
      },
      // 获取当前日期和明天日期
      getCurrentAndTomorrowDates() {
        const today = new Date()
        const tomorrow = new Date(today)
        tomorrow.setDate(tomorrow.getDate() + 1)
        // 格式化为YYYY-MM-DD
        const formatDate = (date) => {
          const year = date.getFullYear()
          const month = String(date.getMonth() + 1).padStart(2, '0')
          const day = String(date.getDate()).padStart(2, '0')
          return `${year}-${month}-${day}`
        }

        var data1 = formatDate(today)
        var data2 = formatDate(tomorrow)
        return {
          today: `${data1} 00:00:00`,
          tomorrow: `${data2} 00:00:00`,
        }
      },
      timeChange(e) {
        if (e.length > 1) {
          this.queryForm.start_time = e[0]
          this.queryForm.end_time = e[1]
        } else {
          this.queryForm.start_time = ''
          this.queryForm.end_time = ''
        }
        this.queryForm.page = 1
        this.fetchData()
      },
      handleSelectionChange(val) {
        this.multipleSelection = val
      },
      out() {
        //
        var arr = []
        this.multipleSelection.forEach((item, index) => {
          arr.push(item.id)
        })
        if (arr.length > 0) {
          var ids = arr.join(',')
          MonadOrder_excel_out({
            id: ids,
          }).then((res) => {
            const fileUrl = getUploadUrl + res.data
            window.open(fileUrl)
            this.$message({
              type: 'success',
              message: '导出成功!',
            })
          })
        } else {
          this.$message({
            type: 'warning',
            message: '未选中任何项!',
          })
        }
      },
      del_item(row) {
        // 删除用户
        this.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            MonadOrder_del({
              id: row.id,
            }).then((res) => {
              this.$message({
                type: 'success',
                message: '删除成功!',
              })
              this.fetchData()
            })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除',
            })
          })
      },
      edit(row) {
        this.$refs['userAdd'].showEdit(row)
      },
      handleQuery() {
        this.queryForm.page = 1
        this.fetchData()
      },
      fetchData() {
        var data = {
          ...this.queryForm,
        }
        this.listLoading = true
        MonadOrder_list(data).then((res) => {
          this.listLoading = false
          this.total = res.data.count
          console.log(res.data.list)
          res.data.list.forEach((item, index) => {
            if (res.data.list[index].pic) {
              res.data.list[index].pic = res.data.list[index].pic.split(',')
            } else {
              res.data.list[index].pic = []
            }
          })
          this.list = res.data.list
        })
      },
      handleSizeChange(e) {
        this.queryForm.limit = e
        this.queryForm.page = 1
        this.fetchData()
      },
      handleCurrentChange(e) {
        this.queryForm.page = e
        this.fetchData()
      },
    },
  }
</script>

<style>
  :deep .right-panel {
    display: flex;
    align-items: center;
  }
</style>
